module.exports = __webpack_public_path__ + "img/00032.df278c16.webp";